import { render, staticRenderFns } from "./Trips.vue?vue&type=template&id=464643d3&scoped=true&"
import script from "./Trips.vue?vue&type=script&lang=js&"
export * from "./Trips.vue?vue&type=script&lang=js&"
import style0 from "./Trips.vue?vue&type=style&index=0&id=464643d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464643d3",
  null
  
)

export default component.exports